/**
 * 传入一个字符串和一系列坐标，指定标签包裹相应坐标的文字
 *
 * @param {string} text - The text to wrap.
 * @param {Array<Array<number>>} coords - 坐标，形如[[1,2],[4,6]]
 * @returns {string} 包裹后的字符串
 */
export const wrapWithTag = (text, coords, tag = 'span', Klass = 'error') => {
  if (!text) return '';
  // 做下升序
  coords = coords.sort((a, b) => a[0] - b[0]);
  var output = '';
  var lastIndex = 0;
  coords.forEach(function (coord) {
    var start = coord[0];
    var end = coord[1];
    output += text.slice(lastIndex, start);
    output += `<${tag} class="${Klass}">${text.slice(start, end)}</${tag}>`;
    lastIndex = end;
  });
  output += text.slice(lastIndex);
  return output;
};

// 去掉空格字符
export const removeEmpty = (str) => {
  return str.replace(/\s+/g, ' ');
};

export const hasValidChar = (str) => {
  // 是否存在非符号的字符
  const regex =
    /[\p{L}\p{N}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}]/u;
  return typeof str === 'string' && regex.test(str);
};
